<template>
    <div id="user">
        <div class="head-tool">
            <span @click="$router.go(-1)">返回</span>
            <span class="tc">个人中心</span>
            <router-link class="tr" tag="span" to="/">首页</router-link>
        </div>
        <div class="userInfo">
            <el-image :src="getCover" >
                <div slot="error" class="image-slot">
                    <img src="./../assets/images/user.png" alt="">
                </div>
            </el-image>
            <div class="info">
                <p>{{getUserInfo.username}} <span>用户编号：{{getUserInfo.id}}</span></p>
                <p class="description">这个人很懒，什么都没有留下</p>
            </div>
        </div>
        <ul>
            <li class="account">
                <el-image :src="require('./../assets/images/1.png')"></el-image>
                <div class="fl">
                    <h3>我的账户</h3>
                    <p>余额：<span>{{getUserInfo.money}}书币</span><span>{{getUserInfo.voucher}}书豆</span></p>
                    <p v-if="getUserInfo.isvip" class="yearvip">会员到期至 <span>{{getUserInfo.viptime}}</span></p>

                </div>
                <router-link to="/recharge">充值</router-link>
            </li>
			<li @click="doVoucher">
				<el-image :src="require('./../assets/images/1.png')"></el-image>
				<p>兑换劵
					<i class="el-icon-arrow-right"></i>
				</p>
			</li>
            <li v-if="getUserInfo.cid == 1">

            <a href="http://author.yuread.net" >
                <el-image :src="require('./../assets/images/0.png')"></el-image>
                <p>作家中心
                    <i class="el-icon-arrow-right"></i>
                </p>
            </a>
            </li>
            <router-link to="/mail" tag="li">
                <el-image :src="require('./../assets/images/4.png')"></el-image>
                <p>站内信息 <span class="mailShow" v-show="mailShow">NEW</span>
                    <i class="el-icon-arrow-right"></i>
                </p>
            </router-link>
            <router-link to="/bill" tag="li">
                <el-image :src="require('./../assets/images/1.png')"></el-image>
                <p>消费记录
                    <i class="el-icon-arrow-right"></i>
                </p>
            </router-link>

            <router-link to="/history" tag="li">
                <el-image :src="require('./../assets/images/3.png')"></el-image>
                <p>最近阅读
                    <i class="el-icon-arrow-right"></i>
                </p>
            </router-link>
            <router-link to="/rechargelist" tag="li">
                <el-image :src="require('./../assets/images/4.png')"></el-image>
                <p>充值记录
                    <i class="el-icon-arrow-right"></i>
                </p>
            </router-link>
            <router-link to="/subscribe" tag="li">
                <el-image :src="require('./../assets/images/5.png')"></el-image>
                <p>我的订阅
                    <i class="el-icon-arrow-right"></i>
                </p>
            </router-link>
            <router-link to="/bindphone" tag="li" v-if="!getUserInfo.phone">
                <el-image :src="require('./../assets/images/6.png')"></el-image>
                <p>绑定手机号（获得150阅读豆）
                    <i class="el-icon-arrow-right"></i>
                </p>
            </router-link>
            <router-link to="/password" tag="li">
                <el-image :src="require('./../assets/images/7.png')"></el-image>
                <p>设置密码
                    <i class="el-icon-arrow-right"></i>
                </p>
            </router-link>
            <router-link to="/customerservice" tag="li">
                <el-image :src="require('./../assets/images/8.png')"></el-image>
                <p>联系客服
                    <i class="el-icon-arrow-right"></i>
                </p>
            </router-link>
        </ul>

        <!--<button class="logout" @click="logout">退出登陆</button>-->
    </div>
</template>

<script>
    export default {
        name: "User",
        data() {
            return {
                mailShow : false
            };
        },
        computed : {
            getUserInfo(){
                return this.$store.getters.getUserInfo;
            },
            getCover(){
                if(this.getUserInfo.cover.indexOf("http") != -1){
                    return this.getUserInfo.cover;
                }
                return "http://static.yuread.cn/" + this.getUserInfo.cover;
            }
        },
        methods : {
			doVoucher(){
				this.$prompt('请输入兑换劵', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					customClass : 'voucher-box'
				}).then(({ value }) => {
					this.axios.post('/api/user/voucher',{
						ikey : value
					}).then(r => {
						alert(r.data.msg)
					})
				}).catch(() => {

				});
			},
            logout(){
                this.axios.post('/api/login/logout').then(r => {

                    this.$store.dispatch('setUserInfo',{});
                    location.href='/'
                })


            },
            resetUserInfo(){
                this.axios.post('/api/user/getUserInfo').then(r => {
                    let data = r.data;
                    if(data.code == 1){
                        this.$store.dispatch('setUserInfo',data.data);
                    }
                })
            },
            getMail(){
                this.axios.post('/api/mail/getMail').then(r => {
                    if(r.data.code){
                        this.mailShow = true;
                    }
                })
            }
        },
        created() {
            this.resetUserInfo();
            if(this.getUserInfo){
                this.getMail();
            }
        }
    }
</script>

<style lang="less">
	.voucher-box{width: 80vw !important;
		.el-message-box__title{font-size: 40px !important;}
		.el-message-box__message{font-size: 32px;}
		.el-input__inner{height: 60px;font-size: 30px;}
		.el-button--mini, .el-button--small{font-size: 30px;}
	}
    #user{background: #f6f6f7;overflow: auto;height: 100%;

        .head-tool{display: flex;padding: 26px 20px;background: #fff;border-bottom: 1px solid #efefef;
            span{flex:1;font-size: 30px;color:#333;
                i{font-size: 30px;}
            }
        }

        .userInfo{overflow: auto;
            padding: 30px; background: #fff;
            .el-image{width: 128px;height:128px;float: left;border-radius: 50%;overflow: hidden;
                img{height: 100%;width: 100%;}
            }
            .info{padding: 20px 0 0 20px;float: left;
                p{font-size: 30px;color:#252424;
                    span{font-size: 24px;color:#6e6e6e;margin-left: 20px;}
                }
                .description{font-size: 26px;color:#a9a9a9;line-height: 50px;}
            }
        }

        ul{background: #fff;margin-top: 20px;
            li{border-bottom: 1px solid #efefef;height: 124px;overflow: hidden;
                .el-image{width: 124px;height:124px;float: left;text-align: center;
                    img{width: 52px;height:52px;border-radius: 50%;margin-top: 36px;}
                }
                p{line-height: 124px;font-size: 30px;
                    i{float: right;line-height: 124px;margin-right:20px;font-size: 30px;}
                    .mailShow{background: @theme;color: #fff;padding: 1px 16px;font-size: 24px;border-radius: 20px;}
                }
                a{color: #000;}
            }
            .account{
                h3{font-size: 30px;font-weight: 400;padding-top: 16px;}
                p{font-size: 24px;line-height: 30px;
                    span{color: @theme;margin-right: 20px;}
                }
                .yearvip{}

                a{float:right;background: @theme;color: #fff;font-size:30px;padding: 5px 30px;border-radius: 30px;margin:35px 20px 0 0;}
            }
        }
        .logout{width:100%;background: #fff;border:none;height:124px;margin-top: 20px;color:@theme;font-size: 30px;}
    }
</style>
